export default "__VITE_ASSET__BCOPvgY4__"